import type { TourDefinition } from "../types";

export const pmSchedulesTour: TourDefinition = {
  id: "pm-schedules",
  titleKey: "onboarding.tours.pmSchedules.title",
  descriptionKey: "onboarding.tours.pmSchedules.description",
  module: "pm-schedules",
  estimatedMinutes: 2,
  steps: [
    {
      id: "pm-schedules-intro",
      targetSelector: "[data-tour='search-input']",
      titleKey: "onboarding.tours.pmSchedules.intro.title",
      descriptionKey: "onboarding.tours.pmSchedules.intro.description",
      placement: "bottom",
      navigateTo: "/pm-schedules",
      waitForSelector: "[data-tour='search-input']",
    },
    {
      id: "pm-schedules-add",
      targetSelector: "[data-tour='create-button']",
      titleKey: "onboarding.tours.pmSchedules.add.title",
      descriptionKey: "onboarding.tours.pmSchedules.add.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[aria-label='Add PM Schedule']",
      highlightPulse: true,
    },
    {
      id: "pm-schedules-fields",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.pmSchedules.fields.title",
      descriptionKey: "onboarding.tours.pmSchedules.fields.description",
      placement: "right",
      waitForSelector: "[role='dialog']",
    },
    {
      id: "pm-schedules-save",
      targetSelector: "[role='dialog'] button[type='submit']",
      titleKey: "onboarding.tours.pmSchedules.save.title",
      descriptionKey: "onboarding.tours.pmSchedules.save.description",
      placement: "top",
      celebration: "checkmark",
    },
  ],
};
